export enum ERoutes{
    DASHBOARD = 'dashboard'
}